import {
  BookOpenTextIcon,
  BooksIcon,
  BuildingApartmentIcon,
  BuildingOfficeIcon,
  FileTextIcon,
  FoldersIcon,
  GearIcon,
  GridNine,
  HouseIcon,
  MagicWandIcon,
  MagnifyingGlassIcon,
  ScanSmileyIcon,
  TShirtIcon,
  UserIcon,
} from '@phosphor-icons/react';
import { NavigationItem } from '@/types/navigation';
import { CompanyModule, RolePermission } from '@/types/schema';

export const welcomeNavigationTabs: NavigationItem[] = [
  {
    label: 'Equipo',
    href: '/team',
  },
  {
    label: 'Recursos',
    href: '/posts',
    subItems: [
      {
        label: 'Publicaciones',
        href: '/posts?category=PUBLICATION',
      },
      {
        label: 'Prensa',
        href: '/posts?category=PRESS',
      },
    ],
  },
  {
    label: 'Contacto',
    href: '/contact-us',
  },
];

export const adminNavigationItems: NavigationItem[] = [
  { label: 'Compañías', href: '/admin/companies', icon: BuildingOfficeIcon },
  { label: 'Usuarios', href: '/admin/users', icon: UserIcon },
  { label: 'Revisiones', href: '/admin/reviews', icon: MagnifyingGlassIcon },
  { label: 'Biblioteca', href: '/admin/library', icon: BooksIcon },
  { label: 'Catálogo', href: '/admin/catalog', icon: TShirtIcon },
];

export const sidebarPrimaryAction: NavigationItem = {
  label: 'Nuevo proyecto',
  href: '/projects/create',
  icon: MagicWandIcon,
  permission: RolePermission.PROJECT_CREATOR,
};

export const sidebarNavigationItems: NavigationItem[] = [
  { label: 'Inicio', href: '/dashboard', icon: HouseIcon },
  { label: 'Marcas', href: '/brands', icon: BuildingApartmentIcon },
  { label: 'Modelos', href: '/models', icon: ScanSmileyIcon },
  {
    label: 'Catálogo',
    href: '/catalog',
    icon: TShirtIcon,
    module: CompanyModule.GARMENT_COMBINATION,
  },
  { label: 'Proyectos', href: '/projects', icon: FoldersIcon },
  {
    label: 'Borradores',
    href: '/drafts',
    icon: FileTextIcon,
    permission: RolePermission.PROJECT_CREATOR,
    module: CompanyModule.PROJECT_DRAFTS,
  },
  {
    label: 'Biblioteca',
    href: '/library',
    icon: BookOpenTextIcon,
    permission: RolePermission.VIEWER,
  },
  { label: 'Métricas', href: '/metrics', icon: GridNine },
  {
    label: 'Administrar',
    href: '/permissions',
    icon: GearIcon,
    permission: RolePermission.PERMISSION_ADMIN,
  },
];
